import { useEffect, useLayoutEffect, useState } from "react"
import React from "react"
import classNames from "classnames"
import { throttle } from "../../../shared/utils/throttle"
import { Icon } from "../icon"
import { Icons } from "../../../types"
import { useAdminContext } from "react-bricks"

const BackToTop = ({}) => {
    const [visible, setVisible] = useState(false)
    const [offset, setOffset] = useState(0)

    const { isAdmin } = useAdminContext()

    useLayoutEffect(() => {
        const handleResize = () => {
            setOffset(window.innerHeight)
        }
        handleResize()
        window.addEventListener("resize", throttle(handleResize))
        return () => {
            window.removeEventListener("resize", handleResize)
        }
    }, [])

    useEffect(() => {
        if (offset === 0) return

        const handleWindowScroll = () => {
            setVisible(document.documentElement.scrollTop > offset)
        }
        handleWindowScroll()
        window.addEventListener("scroll", handleWindowScroll)
        return () => {
            window.removeEventListener("scroll", handleWindowScroll)
        }
    }, [offset])

    return (
        <button
            type="button"
            className={classNames(
                "shadow-black-base fixed bottom-3.5 right-3.5 z-7 flex h-[50px] w-[50px] items-center justify-center rounded-full bg-white transition-opacity duration-300 ease-in-out lg:bottom-7 lg:right-7 lg:h-16 lg:w-16",
                visible || isAdmin ? "opacity-100" : "opacity-0"
            )}
            onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "smooth" })}
        >
            <Icon icon={Icons.next} className="text-blue -rotate-90 text-[19px] lg:text-xl" />
        </button>
    )
}

BackToTop.schema = {
    name: "BackToTop",
    label: "Back-to-Top Button/Sticky",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/BackToTop.png`,
}

export default BackToTop
